<template>
	<div>
		<freemium-locked-alert v-if="$store.company.is_freemium == 1"></freemium-locked-alert>
		<div class="d-flex flex-row align-items-center justify-content-between">
			<h2 v-if="!isWizardInstance">Pay Adjustments</h2>

			<button v-on:click="newAdjustment" class="btn btn-success">
				<i class="fa fa-plus"></i> 
				New Pay Adjustment
			</button>
		</div>

		<onboarding-card v-if="!isWizardInstance" title="Add pay adjustments" name="Pay Adjustment" setting-key="payAdjustments">
			<p>A Pay Adjustment is a boost in pay an employee can when they are entitled to a higher rate of pay. Examples can be an after-hours premium rate, danger pay, or serving as a supervisor.</p>

			<p>Pay Adjustments can be applied globally to all time logged to a specific project, or added as an option to the clock out page, to allow the employee to claim it when they are entitled to. You can set the adjustment to be a percentage of their existing rate (ex 120% of $14/hr), a set increase/hr (ex. +$2/hr on top of their regular pay), or a flat value per time log.</p>
		</onboarding-card>
			
		<table-list
			key="payBoosts"
			:records="mutatedPayBoosts"
			:fields="fields"
			record-name="Pay Adjustment"
			:has-edit="true"
			id-field="slug"
			v-on:edit="editRecord">
		</table-list>

		<modal-dialog
			:modal-visible="editModal.visible"
			:title="editModal.title"
			confirm-button-text="Save"
			v-on:confirm="save"
			v-on:closeModal="editModal.visible = false">

			<field label="Description" col-class="col-md-4" v-model="editModal.payload.description" ></field>

			<field label="Type" col-class="col-md-4" v-model="editModal.payload.type" :params="{type: 'btn-group', buttons: boostTypeBtns }"></field>

			<field label="Amount" col-class="col-md-4" v-model="editModal.payload.amount" :params="{type: 'number', step: 0.01}"></field>

			<field label="When to Apply" col-class="col-md-4" v-model="editModal.payload.always_apply" :params="{type: 'btn-group', buttons:[
				{text: 'Provide option on Clock Out Page',value:0},
				{text: 'Apply Globally to Project',value:1}
			]}"></field>

			<div class="row" v-if="editModal.showDelete">
				<div class="col-sm-3" style="padding-top: 3px;">

					<button type="button" v-if="editModal.record.User && editModal.record.User.length > 0" class="btn btn-outline-danger float-left" disabled><i class="fa fa-trash"></i> Delete</button>

					<button type="button" v-else class="btn btn-outline-danger float-left" v-on:click="deleteItem"><i class="fa fa-trash"></i> Delete</button>

					
				</div>
				<div v-if="editModal.record.User && editModal.record.User.length > 0" class="col-sm-9 text-muted">
					Classifications may only be deleted if no project is using it.
				</div>
			</div>
			

		</modal-dialog>

	</div>
</template>

<script>
import FormGroup from "../../components/FormGroup"
import Field from "../../components/Field"
import TableList from "../../components/TableList"
import ModalDialog from "../../components/ModalDialog"
import OnboardingCard from "@/components/OnboardingCard"
import FreemiumLockedAlert from "@/components/FreemiumLockedAlert"

export default {

	name: 'PayAdjustments',
	components: {
		TableList,
		ModalDialog,
		FormGroup,
		Field,
		OnboardingCard,
		FreemiumLockedAlert
	},
	props: ["isWizardInstance"],
	data() {
		return {
			payBoosts: [],
			boostTypeBtns: [
				{
					icon: "fa-percent",
					text: " of Rate",
					value: 1
				},
				{
					icon: "fa-money-bill",
					text: "/hr",
					value: 0
				},
				{
					icon: "fa-calendar",
					text: "Flat Rate",
					value: 2
				},
			],
			fields: [
				{
					label: "Description",
					key: "description"
				},
				{
					label: "Type",
					key: "boost_type"
				},
				{
					label: "Amount",
					key: "amount_labeled"
				},
				{
					label: "When to Apply",
					key: "whenToApply"
				}
			],
			editModal: {
				visible: false,
				title: "Edit Pay Boost",
				payload: {
					description: "",
					type: 0,
					amount: null
				},
				record: {},
				showDelete: true
			}
		}
	},
	computed: {
		mutatedPayBoosts() {

			return this.payBoosts.map(item => {
				if (item.is_perdiem == 1) {
					item.boost_type = "Per Diem"
					item.amount_labeled = "$ "+item.amount
				}
				else if (item.is_percent == 1) {
					item.boost_type = "%"
					item.amount_labeled = item.amount + "%"
				}
				else {
					item.boost_type = "$"
					item.amount_labeled = "$ "+item.amount+"/hr"
				}

				item.whenToApply = "Clock Out Page"
				if (item.always_apply == 1)
					item.whenToApply = "Applied Globally"

				return item
			})
		}
	},
	methods: {
		newAdjustment() {
			this.editModal.payload = {}
			this.editModal.visible = true
			this.editModal.title = "New Pay Adjustment"
			this.editModal.record = {}
			this.editModal.showDelete = false

			this.editModal.payload.type = 2

		},
		editRecord(record) {
			this.editModal.payload = record
			this.editModal.visible = true
			this.editModal.title = "Edit Pay Adjustment"
			this.editModal.record = record
			this.editModal.showDelete = true

			if (record.is_perdiem == 1) 
				this.editModal.payload.type = 2
			else
				this.editModal.payload.type = record.is_percent

		},
		save() {
			let vm = this

			if (this.editModal.payload.type == 2) {
				this.editModal.payload.is_percent = 0
				this.editModal.payload.is_perdiem = 1
			}
			else {
				this.editModal.payload.is_perdiem = 0
				this.editModal.payload.is_percent = this.editModal.payload.type
			}

			this.saveRecord("PayBoost",this.editModal.payload,function() {
				vm.editModal.visible = false
				vm.alertSaved("Pay Adjustment saved!")
				vm.fetchBoosts()
			})
		},
		deleteItem() {
			let vm = this

			this.deleteRecord('PayBoost',this.editModal.record.id,function() {
				vm.editModal.visible = false;
				vm.alertSuccess("Pay Adjustment deleted!")
				vm.fetchBoosts()
			})
		},
		fetchBoosts() {
			let vm = this

			this.spinner(true)

			this.getJSON("PayBoost/get").then(function(response) {
				if (response.success)
					vm.payBoosts = response.data
				
				vm.spinner(false)
			})	

		}
	},
	created() {
		this.fetchBoosts()

		let vm = this
		//list for new record button click event from parent
		this.$bus.$on("newPayBoost", function(){
			vm.editModal.title = "New Pay Adjustment"
			vm.editModal.payload = {
				description: "",
				is_percent: null,
				amount: null
			}
			vm.editModal.visible = true
			vm.editModal.showDelete = false
		})
	}

}
</script>

